import { Spin } from "antd";
import { StockDetail } from "fin-web-components";
import { H5SubPageShell } from "../../components/common/H5SubPageShell";
import "../../components/common/H5SubPageShell.css";
import { stockDetailPageCssVars } from "./Config";
import { StockDetailHeader } from "./StockDetailHeader";
import { StockDetailKlineSection } from "./StockDetailKlineSection";
import { useStockDetailData } from "./useStockDetailData";
import "./StockDetailPage.css";

export interface H5StockDetailPanelProps {
  stockCode: string;
  onBack: () => void;
}

/** H5 股票详情：顶栏 + 内容，供独立路由页与满屏弹框复用 */
export function H5StockDetailPanel(props: H5StockDetailPanelProps): JSX.Element {
  const { stockCode, onBack } = props;
  const {
    detail,
    dayKlines,
    holderNumbers,
    holderTrades,
    loading,
    klineLoading,
    holderTradesLoading,
    navTitle,
    navSubtitle,
  } = useStockDetailData(stockCode);

  return (
    <H5SubPageShell
      title={navTitle}
      titleSubtitle={navSubtitle}
      shellClassName="lf-stock-detail-shell"
      onBack={onBack}
    >
      <div className="lf-stock-detail-page" style={stockDetailPageCssVars()}>
        <Spin spinning={loading}>
          {detail ? <StockDetailHeader detail={detail} /> : null}
          <StockDetailKlineSection
            dayKlines={dayKlines}
            klineLoading={klineLoading}
            holderNumbers={holderNumbers}
          />
          <StockDetail
            layout="stacked"
            showKlineSection={false}
            stockDetail={detail}
            loading={loading}
            dayKlines={dayKlines}
            klineLoading={klineLoading}
            holderNumbers={holderNumbers}
            holderTrades={holderTrades}
            holderTradesLoading={holderTradesLoading}
          />
        </Spin>
      </div>
    </H5SubPageShell>
  );
}
